import styled from 'styled-components';

interface formPlanGroupProps {
	width?: string;
}

const FormPlanGroup = styled.div<formPlanGroupProps>`
	display: block;
	position: relative;
	box-sizing: border-box;
	width: 98%;
	margin: 0 1%;
	float: left;
	.field-error {
		min-height: 22px;
		margin-top: 5px;
		width: 100%;
		clear: both;
	}
	&.half-width {
		width: 48%;
	}
	#duration {
		width: 60%;
		float: left;
	}
	#durationUnit {
		width: 36%;
		float: right;
		border-radius: 5px;
	}
	.unlimited-check {
		position: absolute;
		right: 0;
		top: 0;
		span {
			color: #58728c;
			margin-right: 5px;
			font-size: 11px;
			vertical-align: text-top;
		}
	}
	[readonly] {
		background-color: #cccccc;
	}
`;

export default FormPlanGroup;
